module.exports = __webpack_public_path__ + "static/media/eye-close.091604e4.svg";